import React from 'react';
import styled from 'styled-components';

import IconSvgComponent from '#/components/basic/icons/IconSvgComponent';
import Link from '#/components/basic/Link/Link';
import { urls } from '#/config/constants';

const LearnMoreWrap = styled.div`
  padding: 22px 8px 0 8px;
  font-size: var(--medium);
`;

const Steps = styled.div`
  padding-top: 8px;
  font-size: var(--medium);
  font-weight: normal;
  line-height: 1.5;
`;

export default function QrSyncSteps({ isDesktop }: { isDesktop: boolean }) {
  return (
    <>
      <Steps>
        <div style={{ paddingBottom: 8 }}>
          1. Go to <b>{urls.exchange}</b> on {isDesktop ? 'mobile' : 'desktop'}{' '}
          and connect a wallet.
        </div>
        <div>
          2. Click the QR icon{' '}
          <IconSvgComponent icon="qrCodeWhite" inline size="16px" /> to link
          your account.
        </div>
      </Steps>
      <LearnMoreWrap>
        <Link href={urls.learnMoreQrSync} underline>
          Learn More
        </Link>
      </LearnMoreWrap>
    </>
  );
}
